<template>

<app-content :loading="is.loading">

	<app-content-head title="Subscription" subtitle="Manage your subscription.">

		<app-content-head-actions-item text="Save" icon="save" :loading="is.saving" v-on:click="onSaveClick" v-if="isActive" />
		<app-content-head-actions-item text="Cancel" :danger="true" icon="membership.cancel" v-on:click="onCancelClick" v-if="isActive" />

    </app-content-head>

	<app-content-body>

		<app-content-summary>

			<app-content-summary-item label="Status" :status="$constants.membership.subscription.statusTheme[subscription.status]" :tag="$constants.membership.subscription.statusName[subscription.status]" />
            <app-content-summary-item label="No." :value="subscription.reference" />
			<app-content-summary-item label="Ref." :value="subscription.referenceRandom" />
			<app-content-summary-item label="Type" :grow="true" :value="subscription.type.name" />
			<app-content-summary-item label="Plan" :value="subscription.plan.name" />
			<app-content-summary-item label="Started" :value="subscription.date.start | localDate('MM/DD/YYYY')" />
			<app-content-summary-item v-if="isActive" label="Next Renewal" :value="subscription.date.renew | localDate('MM/DD/YYYY')" />
			<app-content-summary-item v-if="!isActive" label="Cancelled on" :value="subscription.date.cancelled | localDate('MM/DD/YYYY')" />
			<app-content-summary-item v-if="isExpiring" label="Ends on" :value="subscription.date.renew | localDate('MM/DD/YYYY')" />
			<app-content-summary-item v-if="isCancelled" label="Ended on" :value="subscription.date.renew | localDate('MM/DD/YYYY')" />

        </app-content-summary>

        <div class="grid">

            <com-details :subscription="subscription" v-on:change="onModelChange" />
            <com-renewal :subscription="subscription" :cycle="cycle" />

        </div>

	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

import comDetails from './membershipsubscription/Details'
import comRenewal from './membershipsubscription/Renewal'

export default {

    components: {
        'com-details': comDetails,
        'com-renewal': comRenewal
    },

	data: function() {

		return {
			is: {
				loading: true,
				saving: false
			},
			model: {},
            subscription: {},
            cycle: {}
		}

	},

	created: function() {

		this.load()

	},

    computed: {
    
        isActive: function() {
		
			return this.subscription.status === 1
		
		},

		isCancelled: function() {
		
			return this.subscription.status === 2
		
		},

		isExpiring: function() {
		
			return this.subscription.status === 3
		
		}

    },

	methods: {

		onModelChange: function(model) {
		
			this.model = model

		},

		onSaveClick: function() {
		
			this.is.saving = true

			this.$api.put('membership/subscription', this.model).then(function(json) {

                Vue.set(this, 'subscription', json.subscription)

				this.is.saving = false

			}.bind(this))
		
		},

		onCancelClick: function() {

			this.$router.push({
				name: 'Membership.Subscription.Cancel'
			})

		},

		load: function() {

			this.$api.get('membership/subscription').then(function(json) {

                Vue.set(this, 'subscription', json.subscription)
                Vue.set(this, 'cycle', json.cycle)

				this.model.photo = this.subscription.photo
				this.model.email = this.subscription.email
				this.model.firstname = this.subscription.firstname
				this.model.lastname = this.subscription.lastname

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.summary-wrapper {
	display: flex;
}

.is-mobile .summary-wrapper {
    flex-direction: column;
}

.is-mobile .summary-wrapper >>> .box {
    margin-right: 0px;
}

.grid {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: auto 290px;
    grid-template-rows: 290px;
}

.is-mobile .grid {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: auto;
    grid-template-rows: auto;
}

</style>